module.exports = __webpack_public_path__ + "static/media/crypto_card.0cbecc8b.png";